import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import moment from "moment";

import {
  COMPLETE_SUBSCRIPTION_REQUEST,
  completeSubscriptionSuccess,
  completeSubscriptionError,
} from "./actions";
import { Env } from "../../env";

function* completeSubscriptionRequest(action) {
  const { accessToken, values } = action;
  console.log("values", values);

  const { password, passwordCheck, birthDay, birthMonth, birthYear } = values;

  if (password !== passwordCheck) {
    yield put(
      completeSubscriptionError("Les mots de passe ne correspondent pas.")
    );

    return;
  }

  const birthDate = moment({ y: birthYear, M: birthMonth, d: birthDay }).format(
    "DD/MM/YYYY"
  );

  try {
    yield call(
      axios.patch,
      `${Env.BASE_API_URL}/Accounts`,
      {
        ...values,
        birthDate,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    let error;
    if (err.response && err.response.status === 400) {
      error = "Erreur, veuillez vérifier vos informations.";
    } else if (err.response && err.response.status === 401) {
      error = "Lien expiré, veuillez renouveler la demande.";
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }

    yield put(completeSubscriptionError());
    yield put(flashMessage(error));

    return;
  }

  yield put(completeSubscriptionSuccess());
  yield put(flashMessage("Vos informations ont été enregistrées avec succès."));
}

export default function* watchCompleteSubscriptionRequest() {
  yield takeLatest(COMPLETE_SUBSCRIPTION_REQUEST, completeSubscriptionRequest);
}



// WEBPACK FOOTER //
// ./src/pages/complete-subscription/saga.js